import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { Modal, Button, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import toInteger from 'lodash/fp/toInteger';

import './EditProgressModal.css';

class DatePickerInput extends PureComponent {
    render() {
        const { onClick, value } = this.props;

        return (
            <div className="react-datepicker__input">
                <i className="fa fa-calendar react-datepicker__input--icon" onClick={onClick} />
                <FormControl
                  type="text"
                  className="react-datepicker__input--control"
                  value={value}
                  onClick={onClick}
                  readOnly
                />
            </div>
        );
    }
}

DatePickerInput.propTypes = {
    onClick: PropTypes.func,
    value: PropTypes.string,
};

class EditProgressModal extends PureComponent {
    constructor(props) {
        super(props);

        this.wordCountRef = null;

        this.onSave = this.onSave.bind(this);
        this.onWordCountClick = this.onWordCountClick.bind(this);
        this.setWordCountRef = this.setWordCountRef.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleWordCountChange = this.handleWordCountChange.bind(this);

        this._init();
    }

    _init() {
        const date = moment();

        this.state = {
            date,
            wordCount: this._getWordCount(date) || '',
            userModifiedWordCount: false,
        }
    }

    componentWillReceiveProps(newProps) {
        // If we're displaying the modal or changing the goal
        if ((this.props.show === false && newProps.show === true) || (this.props.goal !== newProps.goal)) {
            this._init();
        }
    }

    _getWordCount(date) {
        const { goal } = this.props;

        const dateStr = date.format('YYYY-MM-DD');
        const wordCount = goal.getIn(['progress', dateStr], 0);

        return wordCount;
    }

    onSave() {
        const { onSave, onHide } = this.props;
        const { date, wordCount } = this.state;

        if (wordCount === '') {
            onHide();
        } else {
            onSave({ date, wordCount: toInteger(wordCount) });
        }
    }

    onWordCountClick({ target }) {
        target.select();
    }

    setWordCountRef(ref) {
        this.wordCountRef = ref;
    }

    handleDateChange(date) {
        let { wordCount, userModifiedWordCount } = this.state;

        const dtWordCount = this._getWordCount(date);
        if (dtWordCount || !userModifiedWordCount) {
            wordCount = dtWordCount;
            userModifiedWordCount = false;
        }

        if (wordCount === 0 && this.wordCountRef) {
            wordCount = '';
            this.wordCountRef.value = '';
        }

        this.setState({
            date,
            wordCount,
            userModifiedWordCount,
        });
    }

    handleWordCountChange({ target: { value } }) {
        this.setState({
            wordCount: value,
            userModifiedWordCount: true,
        });
    }

    render() {
        const { show, onHide, goal } = this.props;
        const { date, wordCount = null } = this.state;

        const minDate = moment(goal.get('start'));
        const maxDate = moment();

        return (
            <Modal bsSize="small" className="edit-progress-modal" show={show} onHide={onHide}>
                <Modal.Body>
                    <FormGroup controlId="datePicker">
                        <ControlLabel>Date</ControlLabel>
                        <DatePicker
                          selected={date}
                          minDate={minDate}
                          maxDate={maxDate}
                          dateFormat="ll"
                          onChange={this.handleDateChange}
                          showClearButton={false}
                          customInput={<DatePickerInput />}
                        />
                    </FormGroup>
                    <FormGroup controlId="wordCount">
                        <ControlLabel>Word Count</ControlLabel>
                        <FormControl
                          type="number"
                          value={wordCount}
                          placeholder="0"
                          inputRef={this.setWordCountRef}
                          onChange={this.handleWordCountChange}
                          onClick={this.onWordCountClick}
                          autoFocus
                        />
                    </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="danger" onClick={onHide}>Cancel</Button>
                    <Button bsStyle="success" onClick={this.onSave}>Save</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

EditProgressModal.propTypes = {
    goal: PropTypes.object.isRequired,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
};

export default EditProgressModal;



// WEBPACK FOOTER //
// ./src/components/widgets/modal/EditProgressModal.js